import store from '@/store';

export const assembleUrl = ({ src, lang, room, deviceId }) => {
  let source = src;
  if (!src.includes('http')) {
    source = location.origin + src;
  }
  try {
    const url = new URL(encodeURI(source));
    // set, NICHT append: bringt die konfigurierte Url den Parameter schon mit,
    // stand er sonst zweimal in der Adresse. Genau das ist bei den Widgets
    // passiert - die Wetter-App bekam '?...&lang=ch&lang=ch_de&room=...', und
    // welchen der beiden Werte der Empfaenger nimmt, ist nicht verlaesslich
    // (URLSearchParams.get liefert den ersten, PHP den letzten).
    url.searchParams.set('lang', lang);
    url.searchParams.set('room', room);
    url.searchParams.set('deviceId', deviceId);
    return url.toString();
  } catch (err) {
    store.dispatch('notification/error', {
      title: 'URL invalid',
      message: err,
    });
  }
  return src;
};

export const queryAssembler = {
  methods: {
    assembleUrl(src) {
      return assembleUrl({
        src,
        lang: this.getLang,
        room: this.getRoom,
        deviceId: this.getDeviceId,
      });
      // let source = src;
      // if (!src.includes('http')) {
      //   source = location.origin + src;
      // }
      // const url = new URL(encodeURI(source));
      // url.searchParams.append('lang', this.getLang);
      // url.searchParams.append('room', this.getRoom);
      // url.searchParams.append('deviceId', this.getDeviceId);
      // return url.toString();
    },
  },
  computed: {
    getLang() {
      return this.$store.state.lang.active;
    },
    getRoom() {
      return this.$store.state.device.room;
    },
    getDeviceId() {
      return this.$store.state.device.deviceId;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/queryAssembler.js